import './style.sass';

import { Row, Col, Container, Button } from 'react-bootstrap';
import QuizOption from '../../components/QuizOption';
import { Images } from '../../components';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Actions from '../../store/actions';
import ReactTooltip from 'react-tooltip';
import { BeatLoader } from 'react-spinners';
import requestElementFullscreen from '../../common/utils';

// 🔽 新增：聊天窗组件（方案B的 fetch 版本）
import ChatAssistant from '../../chat/ChatAssistant';

const STEP4_DEFAULT_VIDEO_BASE_URL = 'https://beec-app174707-dev.s3.us-east-1.amazonaws.com/';
const STEP4_CN_VIDEO_BASE_URL = 'https://beec-step4.oss-cn-beijing.aliyuncs.com/';

export default function Step4({ updateCount }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isCnHost = window.location.hostname === 'learn.beecadvantage.cn';

  const [question, setQuestion] = useState({});
  const [review, setReview] = useState({});
  const [correctSPFAnswer, setCorrectSPFAnswer] = useState('');
  const [videoExists, setVideoExists] = useState(false);
  const [videoLink, setVideoLink] = useState('');
  const [isPassageLoading, setIsPassageLoading] = useState(false);
  const [isVideoCheckLoading, setIsVideoCheckLoading] = useState(true); // 新增：视频检查加载状态
  const isMounted = useRef(true); // Track component mount state

  // 🔽 新增：聊天窗开关
  const [chatOpen, setChatOpen] = useState(false);
  // 🔽 新增：跟踪是否已经点击过帮助按钮
  const [hasClickedHelp, setHasClickedHelp] = useState(false);
  // 🔽 新增：跟踪是否曾经打开过AI chat弹窗
  const [hasOpenedChat, setHasOpenedChat] = useState(false);

  const [
    questionState,
    selectedAnswer,
    reviewStepsSubmitted,
    reviewResponse,
    userQuizId,
  ] = useSelector((state) => {
    return [
      state.review.singleQuestion,
      state.review.selectedAnswer,
      state.review.reviewStepsSubmitted,
      state.review.reviewResponse,
      state.review.userQuizId,
    ];
  });

  // 🔽 新增：从当前题目结构提取“正确/错误答案”（供首条英文 Prompt 使用）
  const getCorrectAnswer = () => (questionState?.answer?.isCorrect ?? '').toString();
  const getWrongAnswers = () => {
    const arr = [];
    if (selectedAnswer && String(selectedAnswer) !== getCorrectAnswer()) {
      arr.push(String(selectedAnswer));
    }
    return arr;
  };

  const normalizeVideoUrl = useCallback(
    (rawVideoUrl) => {
      if (!rawVideoUrl || !isCnHost) return rawVideoUrl;
      return rawVideoUrl.replace(STEP4_DEFAULT_VIDEO_BASE_URL, STEP4_CN_VIDEO_BASE_URL);
    },
    [isCnHost],
  );

  const checkVideoExists = useCallback(async () => {
    try {
      let tagVideoURL = '';
      if (questionState) {
        questionState?.tags?.map((item) => {
          if (item.level === 2 && item.videoURL) {
            tagVideoURL = item.videoURL;
          }
          return null; // 添加返回值
        });
      }
      const videoLink = normalizeVideoUrl(questionState?.answer?.video || tagVideoURL);
      if (videoLink) {
        const response = await fetch(`${videoLink}`);
        if (isMounted.current) {
          setVideoLink(`${videoLink}`);
          setVideoExists(response.status !== 403);
        }
      } else {
        if (isMounted.current) {
          setVideoExists(false);
        }
      }
    } catch (error) {
      console.error('checkVideoExists error:', error);
      if (isMounted.current) {
        setVideoExists(false);
      }
    } finally {
      if (isMounted.current) {
        setIsVideoCheckLoading(false); // 视频检查完成
      }
    }
  }, [normalizeVideoUrl, questionState]);

  useEffect(() => {
    return () => {
      isMounted.current = false; // Cleanup on unmount
    };
  }, []);

  useEffect(() => {
    if (questionState) {
      console.log('questionState, ', questionState);
      console.log('selectedAnswer, ', selectedAnswer);
      setIsPassageLoading(true);
      setQuestion(questionState);
      setIsVideoCheckLoading(true); // 开始检查视频
      checkVideoExists();

      setTimeout(() => {
        if (!isMounted.current) return; // Avoid updates if unmounted
        var doc = [];
        doc = document.getElementsByClassName('line-ref');
        var inputList = Array.prototype.slice.call(doc);
        inputList?.map((item) => {
          try {
            var result = item.innerText.substring(6, item.innerText.length - 1);
            const getLine = document.getElementById(`${result}_start`).nextSibling;
            item.innerHTML = `<a data-tip="${getLine.textContent}" onclick="onLineRefClicked('${result}_start_highlight')" href="#${result}_start">line</a>`;
            document.getElementById(
              `${result}_start`,
            ).innerHTML = `<span id="${result}_start_highlight">${getLine.textContent}</span>`;
            document.getElementById(`${result}_start`).nextSibling.remove();
          } catch (err) {
            console.log('Error in line ref', err);
          }
          return null; // 添加返回值
        });
        setIsPassageLoading(false);
        ReactTooltip.rebuild();
      }, 800);

      if (questionState?.answer?.answerType === 'SPR') {
        try {
          const parsedCorrect = JSON.parse(questionState?.answer?.isCorrect);
          if (Array.isArray(parsedCorrect)) {
            CheckSPRAnswer(parsedCorrect);
          } else {
            setCorrectSPFAnswer(questionState?.answer?.isCorrect || ''); // Fallback to raw string
          }
        } catch (err) {
          console.error(
            'Failed to parse SPR isCorrect:',
            err.message,
            questionState?.answer?.isCorrect,
          );
          setCorrectSPFAnswer(questionState?.answer?.isCorrect || ''); // Fallback to raw string
        }
      }
    }
  }, [questionState, selectedAnswer, checkVideoExists]);

  useEffect(() => {
    if (reviewResponse && isMounted.current) {
      if (reviewResponse?.review) {
        try {
          setReview(JSON.parse(reviewResponse?.review));
        } catch (err) {
          console.error('Failed to parse reviewResponse.review:', err.message);
        }
      }
    }
  }, [reviewResponse]);

  useEffect(() => {
    if (reviewStepsSubmitted && isMounted.current) {
      setReview(reviewStepsSubmitted);
    }
  }, [reviewStepsSubmitted]);

  async function CheckSPRAnswer(correctAnswer) {
    try {
      let displayText = '';
      switch (correctAnswer[0]) {
        case 'MATCH':
          displayText = correctAnswer.slice(1).join(' OR ');
          break;
        case 'RANGE':
          displayText = `Answer should be between ${correctAnswer[1]} - ${correctAnswer[2]}`;
          break;
        default:
          console.warn(`Unknown SPR answer type: ${correctAnswer[0]}`);
          displayText = correctAnswer.join(', '); // Fallback
      }
      if (isMounted.current) {
        setCorrectSPFAnswer(displayText);
      }
    } catch (err) {
      console.error('CheckSPRAnswer failed:', err.message, correctAnswer);
      if (isMounted.current) {
        setCorrectSPFAnswer(correctAnswer.join(', ') || ''); // Fallback
      }
    }
  }

  return (
    <>
      <Container className="step-4">
        {question?.section?.title === 'Reading' && isPassageLoading && (
          <div className="text-center">
            <BeatLoader color={'#10A0DE'} size={30} loading={isPassageLoading} />
          </div>
        )}
        <Row
          style={{ marginRight: '0', flex: '1 1 auto', marginBottom: '12px' }}
          className={question?.section?.title !== 'Reading' ? '' : isPassageLoading ? 'd-none' : ''}
        >
          <Col md={6}>
            <div className="stepBox">
              <div style={{ display: 'flex' }}>
                <h1>{question?.orderId}.</h1>
                <div>
                  <h1
                    className="stepBoxText"
                    dangerouslySetInnerHTML={{
                      __html: question?.title,
                    }}
                  ></h1>
                  {question?.answer?.answerType === 'SINGLE_CORRECT' && (
                    <>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'A'}
                          value={question?.answer?.choices[0]}
                          checked={questionState?.answer?.isCorrect.toUpperCase()}
                          changeChecked={() => {}} // Disabled
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'B'}
                          value={question?.answer?.choices[1]}
                          checked={questionState?.answer?.isCorrect.toUpperCase()}
                          changeChecked={() => {}}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'C'}
                          value={question?.answer?.choices[2]}
                          checked={questionState?.answer?.isCorrect.toUpperCase()}
                          changeChecked={() => {}}
                        />
                      </div>
                      <div style={{ display: 'flex' }}>
                        <QuizOption
                          name={'question_option'}
                          label={'D'}
                          value={question?.answer?.choices[3]}
                          checked={questionState?.answer?.isCorrect.toUpperCase()}
                          changeChecked={() => {}}
                        />
                      </div>
                    </>
                  )}
                  {question?.answer?.answerType === 'SPR' && (
                    <div style={{ display: 'flex' }}>
                      <h5>Correct Answer: {correctSPFAnswer}</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
          <Col style={{ background: '#FFFFFF', textAlign: 'center' }} md={6}>
            <div className="categoryBox">
              {isVideoCheckLoading ? (
                <div className="text-center">
                  <BeatLoader color={'#10A0DE'} size={30} loading={isVideoCheckLoading} />
                </div>
              ) : videoExists ? (
                <video width={'100%'} controls src={videoLink}></video>
              ) : (
                <div
                  className={'description'}
                  dangerouslySetInnerHTML={{
                    __html: question?.answer?.rationale,
                  }}
                />
              )}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'row',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Button
                  style={{
                    background: '#4EA2E2',
                    border: 'none',
                    margin: '10px 5px 10px 0',
                  }}
                  onClick={async () => {
                    const temp = review;
                    if (temp.length >= 3) {
                      if (temp.length === 3) {
                        temp.push({
                          time: 20,
                          answer: 'UNDERSTOOD',
                        });
                      } else if (temp.length > 3) {
                        temp[3] = {
                          time: 20,
                          answer: 'UNDERSTOOD',
                        };
                      }
                      await dispatch(
                        Actions.dispatchUpdateReview({
                          userQuizId: userQuizId,
                          questionId: questionState?.id,
                          reviewFeedback: 'FINISHED',
                          review: JSON.stringify(temp),
                        }),
                      );
                      if (isMounted.current) {
                        navigate('/dashboard?source=review');
                      }
                    }
                    if (reviewStepsSubmitted.length === 3) {
                      const temp = [...reviewStepsSubmitted];
                      temp.push({
                        time: 20,
                        answer: 'UNDERSTOOD',
                      });
                      await dispatch(Actions.saveReviewStep(temp));
                      if (isMounted.current) {
                        navigate('/dashboard?source=review');
                      }
                    }
                  }}
                >
                  I understand this question
                </Button>

                <Button
                  variant="warning"
                  style={{ border: 'none', margin: '10px 0 10px 5px' }}
                  onClick={async () => {
                    // ✅ 打开聊天窗（首次自动把题干+正确+错误答案发给 AI，英文讲解）
                    setChatOpen(true);
                    setHasOpenedChat(true); // 标记已打开过弹窗
                    // 标记已经点击过帮助按钮
                    if (!hasClickedHelp) {
                      setHasClickedHelp(true);
                    }

                    // 仍保留你原来的"FLAGGED"上报逻辑；若不想离开本页，可别 navigate
                    const temp = review;
                    if (temp.length >= 3) {
                      if (temp.length === 3) {
                        temp.push({ time: 20, answer: 'FLAGGED' });
                      } else if (temp.length > 3) {
                        temp[3] = { time: 20, answer: 'FLAGGED' };
                      }
                      await dispatch(
                        Actions.dispatchUpdateReview({
                          userQuizId: userQuizId,
                          questionId: questionState?.id,
                          reviewFeedback: 'FLAGGED',
                          review: JSON.stringify(temp),
                        }),
                      );
                      // ❌ 不跳转，停留在本页给用户聊天
                      // if (isMounted.current) navigate('/dashboard?source=review');
                    }
                    if (reviewStepsSubmitted.length === 3) {
                      const temp2 = [...reviewStepsSubmitted];
                      temp2.push({ time: 20, answer: 'UNDERSTOOD' });
                      await dispatch(Actions.saveReviewStep(temp2));
                      // ❌ 不跳转
                      // if (isMounted.current) navigate('/dashboard?source=review');
                    }
                  }}
                >
                  I need help with this question
                </Button>
              </div>
              
              {/* 🔽 新增：只要打开过AI chat弹窗就显示返回仪表板按钮 */}
              {hasOpenedChat && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: '10px',
                  }}
                >
                  <Button
                    style={{
                      background: '#999999',
                      border: 'none',
                      margin: '10px 0',
                    }}
                    onClick={async () => {
                      const temp = review;
                      if (temp.length >= 3) {
                        if (temp.length === 3) {
                          temp.push({
                            time: 20,
                            answer: 'FLAGGED',
                          });
                        } else if (temp.length > 3) {
                          temp[3] = {
                            time: 20,
                            answer: 'FLAGGED',
                          };
                        }
                        await dispatch(
                          Actions.dispatchUpdateReview({
                            userQuizId: userQuizId,
                            questionId: questionState?.id,
                            reviewFeedback: 'FLAGGED',
                            review: JSON.stringify(temp),
                          }),
                        );
                        if (isMounted.current) {
                          navigate('/dashboard?source=review');
                        }
                      }
                      if (reviewStepsSubmitted.length === 3) {
                        const temp = [...reviewStepsSubmitted];
                        temp.push({
                          time: 20,
                          answer: 'UNDERSTOOD',
                        });
                        await dispatch(Actions.saveReviewStep(temp));
                        if (isMounted.current) {
                          navigate('/dashboard?source=review');
                        }
                      }
                    }}
                  >
                    Go back to dashboard
                  </Button>
                </div>
              )}
            </div>
          </Col>
        </Row>

        {!question?.passage?.direction &&
        !question?.passage?.attribution &&
        !question?.passage?.body ? null : (
          <div className="passageBox">
            <div className="right-action">
              <img
                alt="fullScreen"
                onClick={() => {
                  let element = document.getElementsByClassName('passageBox')[0];
                  requestElementFullscreen(element);
                }}
                src={Images.expandImage}
              />
            </div>
            <h1
              className="passageBoxHeading"
              dangerouslySetInnerHTML={{
                __html: question?.passage?.direction,
              }}
            ></h1>
            <div
              dangerouslySetInnerHTML={{
                __html: question?.passage?.attribution,
              }}
            ></div>
            <div
              className={'description'}
              dangerouslySetInnerHTML={{
                __html: question?.passage?.body,
              }}
            />
          </div>
        )}
      </Container>

      {/* 🔽 新增：聊天窗挂载（方案B） */}
      <ChatAssistant
        isOpen={chatOpen}
        onClose={() => setChatOpen(false)}
        onOpen={() => {
          setChatOpen(true);
          setHasOpenedChat(true); // 标记已打开过弹窗
        }}
        questionObj={questionState}
        getCorrect={getCorrectAnswer}
        getWrongs={getWrongAnswers}
        selectedAnswer={selectedAnswer}
        passage={question?.passage}
        autoSendFirstMessage={hasClickedHelp}
      />
    </>
  );
}
